import React, { Component } from 'react';
import DrcSelect from './DrcSelect';
import DrcIcons from '../Utilities/DrcIcons';
import { components } from 'react-select';

const Option = (props) => {
    return (
        <components.Option {...props}>
            {DrcIcons.GetSmallBerryIcon(props.data.value)}
            <span style={{ marginLeft: '10px', lineHeight: '22px', verticalAlign: 'top' }}>{props.data.label}</span>
        </components.Option>
    );
};

const ValueContainer = ({ children, ...props }) => {
    if (!props.hasValue) {
        return <components.ValueContainer {...props}>{children}</components.ValueContainer>;
    }

    return (
        <components.ValueContainer {...props}>
            {DrcIcons.GetSmallBerryIcon(props.selectProps.value.value)}
            <span style={{ marginLeft: '10px', lineHeight: '22px', verticalAlign: 'top' }}>{props.selectProps.value.label}</span>
        </components.ValueContainer>
    );
};

export const BerryTypeOptions = [
    { value: 1, label: 'BLACK' },
    { value: 2, label: 'BLUE' },
    { value: 3, label: 'RASP' },
    { value: 4, label: 'STRAW' }
];

/**
 * @description DrcBerrySelect is a select that shows the list of berries (BLACK, BLUE, RASP, STRAW).
 * @class DrcBerrySelect
 * @property {function} onChange callback to manage select change.
 * @property {number} value value of the selected item.
 * @property {object} containerStyle custom style for the select container.
 * @property {object} other object with other properties to apply in the select.
 * @example <DrcBerrySelect onChange={callback} value={2} />
 * @category Input
 * @tags input select berries berry icon icons pretty
 * @extends {React.Component}
 */
class DrcBerrySelect extends Component {
    /**
     * @description render method for the DrcBerrySelect, part of the react component lifecyle.
     * @return {*} the view for this component.
     * @memberof DrcBerrySelect
     */
    render() {
        const { onChange, value, containerStyle, ...other } = this.props;

        return (
            <DrcSelect
                name="BerryType"
                label="Berry Type"
                value={value}
                onChange={onChange}
                options={BerryTypeOptions}
                components={{ Option, ValueContainer }}
                isClearable={true}
                containerStyle={containerStyle}
                {...other}
            />
        );
    }
}

export default DrcBerrySelect;
